import { useEffect, useCallback, useMemo } from 'react';
import { NO_LICENSE_PLC } from '../constants';
import { ACTIONS } from '../state/actions';
import {
  classifyOfferings,
  buildGetAccountUserOfferingsRequest,
} from '../utils';

const useOfferingsEvents = ({
  accountId,
  assignDropdownLicense,
  dispatch,
  doFetchUserOfferings,

  licenseDropdownPreviousValue,
  licenseLicenseChangeTimeStamp,
  loadingAssignOfferingData,

  loadingUnassignOfferingData,
  offerings,
  offeringsDataError,
  onTryAgainClick,
  unassignDropdownLicense,
  user,
  userOfferingsData,
  userOfferingsDataError,
  state,
}) => {
  const handleTryAgainClick = () => {
    if (offeringsDataError) {
      onTryAgainClick();
    }
    if (userOfferingsDataError) {
      doFetchUserOfferings(
        buildGetAccountUserOfferingsRequest(user.id, accountId)
      );
    }
  };

  const handleLicenseChange = useCallback(
    (value, category) => {
      const previousValue =
        state.subscription.currentOfferings[category].selectedOffering;
      // eslint-disable-next-line no-param-reassign
      licenseDropdownPreviousValue.current = previousValue;
      // eslint-disable-next-line no-param-reassign
      licenseLicenseChangeTimeStamp.current = Date.now();
      const previousValuePlc = previousValue ? previousValue.plc : null;
      const newValuePlc = value ? value.plc : null;
      if (newValuePlc !== previousValuePlc) {
        if (previousValuePlc === null || previousValuePlc === NO_LICENSE_PLC) {
          if (newValuePlc !== null && newValuePlc !== NO_LICENSE_PLC) {
            assignDropdownLicense(
              value.plc,
              value.offeringExternalKey,
              value.category,
              value.categoryName,
              value.licensingModel,
              false
            );
          }
        } else {
          unassignDropdownLicense(
            previousValue.plc,
            previousValue.offeringExternalKey,
            newValuePlc !== NO_LICENSE_PLC && newValuePlc !== null,
            previousValue.category,
            previousValue.categoryName,
            previousValue.licensingModel
          );
        }
      }
      dispatch({
        type: ACTIONS.SET_SELECTED_OFFERING,
        payload: {
          category,
          offering: value,
        },
      });
    },
    [
      assignDropdownLicense,
      dispatch,
      state.subscription.currentOfferings,
      unassignDropdownLicense,
    ]
  );

  const savingInputInfo = useMemo(() => {
    return {
      category: state.subscription.currentOperation.category,
      saving: loadingAssignOfferingData || loadingUnassignOfferingData,
      saved: state.subscription.currentOperation.saved,
    };
  }, [
    loadingAssignOfferingData,
    loadingUnassignOfferingData,
    state.subscription.currentOperation,
  ]);

  useEffect(() => {
    if (!offerings || !userOfferingsData) return;

    const classifiedOfferings = classifyOfferings(
      offerings,
      userOfferingsData.results,
      state.subscription.currentOfferings
    );

    dispatch({
      type: ACTIONS.SET_OFFERINGS,
      payload: classifiedOfferings,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offerings, userOfferingsData]);

  return {
    handleLicenseChange,
    handleTryAgainClick,
    savingInputInfo,
  };
};

export default useOfferingsEvents;
